import { useEffect } from 'react';
import { ErrorKey } from '../app-active-error/ErrorKey';
import { LoadingKey } from '../app-active-loading/LoadingKey';
import { setError } from '../store/error/action-creators';
import { useAppDispatch } from './useAppDispatch';
export const useSetErrorAfterTimeout = (loadingKey, delay = 10000, errorKey = ErrorKey.BlankScreenLoadingError) => {
  const isBlankLoadingScreen = loadingKey === LoadingKey.BlankScreenLoading;
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!isBlankLoadingScreen) return () => {};
    const creationHangingTimeout = setTimeout(() => {
      dispatch(setError(errorKey));
    }, delay);
    return () => clearTimeout(creationHangingTimeout);
  });
};